import { useState } from "react";
import Sidebar from "./components/Sidebar";
import ChatAvaliador from "./components/ChatAvaliador";
import Historico from "./components/Historico";
import Stats from "./components/Stats";
import { useAvaliacoes } from "./hooks/useAvaliacoes";
import "./index.css";

export default function App() {
  const [aba, setAba] = useState("chat");
  const [edital, setEdital] = useState("PROBEX 2019");
  const { avaliacoes, salvar, remover, limparTodas } = useAvaliacoes();

  function novaAvaliacao() {
    setAba("chat");
  }

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <Sidebar
        aba={aba} setAba={setAba}
        avaliacoes={avaliacoes}
        onNova={novaAvaliacao}
        onRemover={remover}
      />
      <div style={{ flex: 1, overflow: "hidden" }}>
        {aba === "chat" && <ChatAvaliador onSalvar={salvar} edital={edital} setEdital={setEdital} />}
        {aba === "historico" && <Historico avaliacoes={avaliacoes} onRemover={remover} onLimpar={limparTodas} />}
        {aba === "stats" && <Stats avaliacoes={avaliacoes} />}
      </div>
    </div>
  );
}
